<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-overlay :value="isAutoSaving" z-index="9999" opacity="0.8" v-if="AutoSave">
          <div class="text-center d-flex flex-column align-center justify-center">
            <atom-spinner :animation-duration="1500" :size="100" class="mx-auto" color="#038118"/>
            <h3 class="mt-4 green--text">در حال ذخیره سازی خودکار...</h3>
            <p class="green--text mt-2">لطفاً چند لحظه صبر کنید</p>
          </div>
      </v-overlay>
      <v-row class="pa-2" no-gutters v-if="showGatewayPopup">
        <v-col cols="12">
          <qr-edit-gateway
            v-model="showGatewayPopup"
            :sections="gatewaySections"
            :form-data="data"
            @edit-all="handleEditAll"
            @save="qrUpdate(false)"
            @cancel="onCancel"
          >
            <template v-slot:preview style="position: relative; min-height: 100%;">
              <v-card
                v-if="loading || qrLoading"
                class="d-flex align-center justify-center mt-10"
                flat
                min-height="50vh"
              >
                <v-progress-circular indeterminate size="50" width="5" color="gray" />
              </v-card>
              <div v-else class="sticky-preview">
                <view-shop
                  v-model="data"
                  :loading="loading || qrLoading"
                  :qr-svg-data-url="qrSvgDataUrl"
                />
              </div>
            </template>
          </qr-edit-gateway>
        </v-col>
      </v-row>
      <v-card :loading="loading" flat v-if="!showGatewayPopup">
        <v-row class="pa-2" no-gutters>
          <v-col class="pa-2" cols="12" md="4">
            <view-shop
              v-model="data"
              :loading="loading || qrLoading"
              class="sticky-md"
              style="top: 110px"
              :qr-svg-data-url="qrSvgDataUrl"
            />
          </v-col>

          <v-col class="pa-2 px-0" cols="12" md="8">
            <v-card :disabled="loading" flat>
              <v-stepper
                v-model="e6"
                class="px-0 mx-0 qr-stepper"
                flat
                vertical
              >
                <v-stepper-step
                  :complete="e6 > 1"
                  class="px-0 px-md-4"
                  step="1"
                >
                  <div class="row justify-center">
                    <div class="col-md-12">
                      <p>{{ $t("shop.step_products_and_info") }}</p>
                    </div>
                    <div class="col-md-6 mt-0 pt-0">
                      <div class="rowinfo">
                        <v-text-field
                          v-model="data.visitName"
                          :disabled="e6 > 2"
                          append-icon="mdi-pen"
                          class="mt-0 pt-0 contentinfo"
                          clear-icon="mdi-close-circle-outline"
                          clearable
                          dense
                          :label="$t('shop.online_store_name')"
                          outlined
                        />
                        <help-info
                          :element-name="`${serviceName}-${componentName}-visitName`"
                          :service-name="serviceName"
                          :help-data="helpData"
                          class="buttoninfo"
                          :label="$t('shop.online_store_name')"
                        />
                      </div>
                    </div>
                    <div class="col-md-6 mt-0 pt-0">
                      <div class="rowinfo" style="display: flex !important">
                        <qr-address-field
                          id="qr-address"
                          v-model="res.identifier"
                          :domain-id="res.domain_id"
                          :error-messages="errors['identifier']"
                          append-icon="mdi-web"
                          class="mt-0 pt-0 contentinfo"
                          style="flex: 1 1 auto !important"
                          dense
                          :hint="$t('shop.qr_address_hint')"
                          outlined
                          persistent-hint
                          readonly
                          :key="$t('qrAddressUpdate.hints.allowedChars')"
                        />
                        <help-info
                          :element-name="`${serviceName}-${componentName}-res-identifier`"
                          :service-name="serviceName"
                          :help-data="helpData"
                          class="buttoninfo"
                          :label="$t('shop.qr_address')"
                        />
                      </div>
                    </div>
                  </div>
                </v-stepper-step>
                <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="1">
                  <v-card-actions
                    class="justify-end"
                  >
                    <v-switch
                      v-model="data.product.onlineShop"
                      class="ma-0"
                      dense
                      hide-details
                      inset
                      :label="$t('shop.online_sale')"
                    />
                  </v-card-actions>
                  <div class="mb-4 mx-4">
                  <!-- سوییچ و آیکون راهنما -->
                  <div class="d-flex align-center">
                    <v-switch
                      v-model="AutoSave"
                      color="primary"
                      class="mt-0 pt-0 shrink"
                      hide-details
                      label="ذخیره خودکار"
                    ></v-switch>

                    <!-- آیکون راهنما با Tooltip (هاور برای دسکتاپ و تاچ برای موبایل) -->
                    <v-tooltip bottom max-width="320">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          x-small
                          class="mr-1"
                          v-bind="attrs"
                          v-on="on"
                          @click.stop
                        >
                          <v-icon small color="grey darken-1">
                            mdi-help-circle-outline
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>
                        تغییرات هر بخش با بستن آن بخش به‌صورت خودکار ذخیره می‌شود. (تنظیمات کلی شامل ذخیره خودکار نیستند)
                      </span>
                    </v-tooltip>
                  </div>
                  <div
                    v-if="$vuetify.breakpoint.xsOnly"
                    class="text-caption grey--text text--darken-1 mt-1 pr-1"
                    style="line-height: 1.4"
                  >
                    تغییرات هر بخش با بستن آن بخش به‌صورت خودکار ذخیره می‌شود. (تنظیمات کلی شامل ذخیره خودکار نیستند)
                  </div>
                </div>


                  <list-expansion
                    v-model="data"
                    :components="specialInfo"
                    :data="data"
                    flat
                    @save-required="AutoSave && qrUpdate(false)"
                  />

                  <div class="col-md-12">
                    <next-btn
                      :loading="loading"
                      style="background: #1b8d39"
                      @click="e6 = 2"
                    />
                  </div>
                </v-stepper-content>

                <v-stepper-step
                  :complete="e6 > 2"
                  class="px-0 px-md-4"
                  step="2"
                >
                  {{ $t("shop.step_content_settings") }}
                </v-stepper-step>
                <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="2">
                  <list-expansion
                    v-model="data"
                    :components="specialInfo2"
                    :data="data"
                    flat
                    @save-required="AutoSave && qrUpdate(false)"
                  />

                  <div class="row mx-auto">
                    <div class="col-md-6">
                      <prev-btn :loading="loading" @click="e6 = 1" />
                    </div>
                    <div class="col-md-6">
                      <next-btn
                        :loading="loading"
                        style="background: #1b8d39"
                        @click="
                        qrUpdate(true);
                        if(!!data.product?.onlineShop)
                          e6++;
                        if (!data.product || !data.product?.onlineShop)
                            goto('qr/list');"
                      />
                    </div>
                  </div>
                </v-stepper-content>

                <v-stepper-step v-if="data?.product?.onlineShop"
                  :complete="e6 > 3"
                  class="px-0 px-md-4"
                  step="3"
                >
                  {{ $t("shop.step_sale_settings") }}
                </v-stepper-step>
                <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="3">
                  <qr-shop-manager
                    ref="qrShop"
                    :domain="domainName"
                    :loading.sync="loading"
                    :qr-id="qrId"
                  />

                  <div class="row mx-auto">
                    <div class="col-md-6">
                      <prev-btn :loading="loading" @click="e6 = 2" />
                    </div>

                    <div class="col-md-6">
                      <next-btn
                        :loading="loading"
                        @click="updateShopSettings"
                      />
                    </div>
                  </div>
                </v-stepper-content>
              </v-stepper>
            </v-card>
          </v-col>
        </v-row>
      </v-card>
    </template>
  </help-info-wrapper>
</template>

<script>
import QrAddressField from "@/view/content/fragments/qrAddressField";
import ListExpansion from "@/view/content/fragments/listExpansion";
import NextBtn from "@/view/content/fragments/nextBtn";
import QrManagement from "@/view/pages/qrland/components/qrManage/qrManagement";
import PrevBtn from "@/view/content/fragments/prevBtn";
import QrCustomize from "@/view/pages/qrland/components/qrCustomize";
import { Bus } from "@/main";
import ViewShop from "@/view/pages/businessPage/pages/shopPage/viewShop";
import { mapActions, mapState } from "vuex";
import QrShopManager from "@/view/pages/qrland/components/qrManage/manageShop/qrShopManager.vue";
import { getLanguageCookie } from "../../../../../core/plugins/TitleRibbon/utils/languageCookie";
import QrEditGateway from "../../../qrland/components/QrEditGateway.vue";
import { AtomSpinner } from "epic-spinners";

export default {
  name: "editShop",

  components: {
    QrShopManager,
    ViewShop,
    QrCustomize,
    PrevBtn,
    QrManagement,
    NextBtn,
    ListExpansion,
    QrAddressField,
    QrEditGateway,
    AtomSpinner
  },

  provide: {
    productImageSize: "128",
  },

  data() {
    return {
      qrSvgDataUrl:'',
      AutoSave:false,
      isAutoSaving: false, 
      showGatewayPopup: this.$route?.query?.gateway === 'true', // وضعیت گیت‌وی
      serviceName: "Qrland",
      componentName: "editShop-b",
      helpData: [],
      qrDesign: {},
      e6: 1,
      errors: {},
      shortId: null,
      finish: true,
      loading: false,
      showDialog: false,
      dtUrl: null,
      domainId: "",
      qrShow: 1,
      res: {},
      data: {
        language: "fa",
        shopLoginConfig: {
          shopLogo: [
            { value: "logo", name: "", logo: "" },
            { value: "background", name: "", background: "" },
          ],
          configs: { subtitle: "" },
        },
        banner: { gallery: null },
        consultation: {
          description: "",
          sectionColor: { backGround: "", text: "" },
        },
        photoSlider: false,
        gallerySlider: false,
        isGradient: false,
        personnel: { items: [] },
        WorkSheet: { /* ... داده‌های قبلی حفظ شده است ... */ },
        Counter: {
          until: "2026-03-21 00:00:00",
          type: "countdown_2",
          title: "",
          description: "",
        },
        product: {
          title: "",
          description: "",
          sectionColor: {
            backGround: "linear-gradient(to right , #350808, #1C107CFF)",
            text: "#fff",
          },
          items: [],
          onlineShop: true,
        },
        specialCategories: {
          title: "",
          description: "",
          sectionColor: {
            backGround: "linear-gradient(to right , #350808, #1C107CFF)",
            text: "#fff",
          },
          items: [],
        },
        visitName: "",
        organizationName: "",
        subOrgan: "",
        userName: "",
        workField: "",
        phoneNumber: [
          { number: "90007425" },
          { number: "02191017077" },
          { number: "09999903535" },
        ],
        extraFields: [ /* ... */ ],
        companyNumber: "02191017077",
        email: "9100terminalads@gmail.com",
        fax: "02191016066",
        location: "",
        city: "",
        codePostal: "1541946815",
        province: "",
        country: "",
        website: "www.terminalads.com",
        socialMedia: { /* ... */ },
        aboutUs: "",
        copyright: "",
        center: [51.420296, 35.732379],
        coordinates: [51.420296, 35.732379],
        address: "",
        pallete: {},
        textCards: {
          sectionColor: {
            backGround: "linear-gradient(to bottom , #C22121FF, #130000FF)",
            text: "#fff",
          },
        },
        pdfSelector: {
          description: "",
          sectionColor: { backGround: "", text: "" },
          slider: false,
          layout: "list",
        },
        Blog: {
          description: null,
          slide: true,
          sectionColor: { backGround: "", text: "" },
          slider: true,
        },
        CounterService: { /* ... */ },
        PicSelector: {
          description: null,
          sectionColor: { backGround: "", text: "" },
          slider: true,
        },
        VideoGallery: {
          description: "",
          sectionColor: { backGround: "", text: "" },
          title: "",
        },
        ServiceSection: { /* ... */ },
        faq: { /* ... */ },
        Service: {
          slider: false,
          description: null,
          sectionColor: { backGround: "", text: "" },
        },
        FeedBack: { /* ... */ },
        apiKey: "eyJ0eXAiOiJKV1Qi...", // حفظ شده
        pdf: null,
        blog: [],
        service: [ /* ... */ ],
        gallery: [ /* ... */ ],
        video_gallery: [ /* ... */ ],
      },
      qrLoading: false,
    };
  },

  mounted() {
    this.fetchData();

    Bus.$on("socialMedias", (value) => {
      this.data.socialMedia = value;
    });
    this.$nextTick(() => {
      const url = this.roboatUrl;

      if (!this.data.ServiceSection?.items?.[0]?.section?.object?.url) {
        this.$set(
          this.data.ServiceSection.items[0].section.object,
          "url",
          `${url}/upload/666d5c59898ed.webp`,
        );
      }

      if (this.data.gallery?.[0]?.images?.length > 0) {
        const images = this.data.gallery[0].images;
        if (images[0]?.url?.includes("6676afd6ecb43.jpg") === false) {
          images[0].url = `${url}/upload/6676afd6ecb43.webp`;
          images[1].url = `${url}/upload/6676afdcdc7cb.webp`;
          images[2].url = `${url}/upload/6676afe735707.webp`;
        }
      }
    });
  },

  computed: {
    roboatUrl() {
      return this.$roboatUrl || "";
    },
    ...mapState("local", ["identifier", "domain", "qr_id", "qrInfo"]),
    cons() {
      return { title: this.$t("shop.download_qr") };
    },
    domainName() {
      return this.$route.params?.name?.replace('?gateway=true','');
    },
    qrId() {
      return this.$route.params?.id?.replace('?gateway=true','');
    },
    
    gatewaySections() {
      const combined = [...this.specialInfo, ...this.specialInfo2];
      return combined.map((item) => {
        return { ...item, description: item.title };
      });
    },

    specialInfo() {
      return [
        {
          name: "shopLoginConfig",
          value: "",
          title: this.$t("shop.login_settings"),
          subtitle: "",
          icon: "home-import-outline",
          model: "shopLoginConfig",
          tabs: [
            {
              title: this.$t("shop.store_logo_images"),
              icon: "mdi-cards-playing-heart-outline",
              component: "shopLogo",
              model: "shopLogo",
            },
            {
              title: this.$t("shop.login_page_info"),
              icon: "mdi-view-carousel-outline",
              component: "shopLoginConfig",
              model: "configs",
            },
          ],
        },
        {
          name: "bannerSelector",
          value: "",
          title: this.$t("shop.upload_banner"),
          subtitle: "",
          icon: "image",
          model: "banner",
        },
        {
          name: "textCards",
          value: "",
          title: this.$t("shop.user_info"),
          subtitle: "",
          icon: "account-outline",
        },
        {
          name: "Product",
          value: "",
          title: this.$t("shop.create_product"),
          subtitle: "",
          icon: "sign-yield",
          model: "product",
          arm: [],
        },
        {
          name: "specialCategoryManager",
          value: "",
          title: this.$t("shop.special_sale"),
          subtitle: "",
          icon: "star-box-outline",
          model: "specialCategories",
        },
        {
          name: "socialMediaIcons",
          value: "",
          title: this.$t("shop.add_social_media"),
          subtitle: "",
          icon: "instagram",
          model: "socialMedia",
        },
        {
          name: "Blog",
          value: "",
          title: this.$t("shop.blog"),
          subtitle: "",
          icon: "text",
        },
        {
          name: "Service",
          value: "",
          title: this.$t("shop.services"),
          subtitle: "",
          icon: "toolbox-outline",
        },
        {
          name: "Faq",
          value: "",
          title: this.$t("shop.faq"),
          subtitle: "",
          icon: "help",
          model: "faq",
        },
      ];
    },
    specialInfo2() {
      return [
        {
          name: "PicSelector",
          value: "",
          title: this.$t("shop.photo_gallery"),
          subtitle: "",
          icon: "image",
        },
        {
          name: "VideoGallery",
          value: "",
          title: this.$t("shop.video_gallery"),
          subtitle: "",
          icon: "video",
        },
        {
          name: "pdfSelector",
          value: "",
          title: this.$t("shop.pdf_gallery"),
          subtitle: "",
          icon: "file",
        },
        {
          name: "FeedBack",
          value: "",
          title: this.$t("shop.feedback"),
          subtitle: "",
          icon: "reply",
          model: "FeedBack",
        },
        {
          name: "Counter",
          value: "",
          title: this.$t("shop.countdown"),
          subtitle: "",
          icon: "timer",
          model: "Counter",
        },
        {
          name: "consultation",
          value: "",
          title: this.$t("shop.request_form"),
          subtitle: "",
          icon: "list-box-outline",
          model: "Consultation", // Note: Consultation vs consultation
        },
        {
          name: "ServiceSection",
          value: "",
          title: this.$t("shop.create_section"),
          subtitle: "",
          icon: "post",
          model: "ServiceSection",
        },
        {
          name: "CounterService",
          value: "",
          title: this.$t("shop.achievements"),
          subtitle: "",
          icon: "post",
          model: "CounterService",
        },
        {
          name: "Personnel",
          value: "",
          title: this.$t("shop.team_members"),
          subtitle: "",
          icon: "account-multiple",
          model: "personnel",
        },
        {
          name: "WorkSheet",
          value: "",
          title: this.$t("shop.working_hours"),
          subtitle: "",
          icon: "timer",
          model: "WorkSheet",
        },
      ];
    },
  },

  watch: {
    "$i18n.locale": {
      handler() {
        this.$forceUpdate();
      },
      immediate: true,
    },
  },

  methods: {
    ...mapActions("localstorage", ["setCreatedQrID", "setQrType"]),
    ...mapActions("local", [
      "updateQrId",
      "updateQridentifier",
      "updateQrInfo",
      "updateQrDomain",
    ]),

    // متدهای کنترل Gateway
    handleEditAll() {
      this.showGatewayPopup = false;
    },
    onCancel() {
      this.$router.push({ name: "qr.list" });
    },

    fetchData() {
      this.qrLoading = true;

      this.$api
        .get(
          `/v1/testQr/find/${this.domainName}${
            !!this.qrId ? "/" + this.qrId : ""
          }`,
        )
        .then(({ data }) => {
          let input = this.fixData(data.data.data.data);
          this.setCreatedQrID(data.data.id);
          this.updateQrDomain();
          this.updateQrId(data.data.id);
          this.updateQridentifier(data.data.identifier);
          this.setQrType(data.data.type);
          this.qrSvgDataUrl= data?.data?.img_url||''; 
          if (this.$refs.qrShop) this.$refs.qrShop.handleQrType();
          this.data = input;
          this.res = data.data;
          let info = data.data.data;

          if (!Object.hasOwn(info.data.product, "onlineShop")) {
            info.data.product.onlineShop = true;
            this.$nextTick(() => {
              if (this.$refs.qrShop) {
                this.$refs.qrShop.fetchSettings();
                this.$refs.qrShop.fetchNumbers();
              }
            });
          } else if (info?.data?.product?.onlineShop) {
            this.$nextTick(() => {
              if (this.$refs.qrShop) {
                this.$refs.qrShop.fetchSettings();
                this.$refs.qrShop.fetchNumbers();
              }
            });
          }
        })
        .finally(() => (this.qrLoading = false));
    },
    qrUpdate(final = false) {
      if (final || !this.AutoSave) {
        this.loading = true;
      } else {
        this.isAutoSaving = true;
      }
      const data = new FormData();
      try {
        if(this.data.product) {
          this.data.product.items = [];
        }
        this.data.language = getLanguageCookie() || this.$i18n.locale || "fa";

        data.append("type", "bShop");
        data.append("qrType", "dynamic");
        data.append("domain", this.res.domain.name);
        data.append("identifier", this.res.identifier);
        data.append("qr_id", this.res.qrId);
        data.append(
          "data",
          JSON.stringify({
            theme: "",
            data: this.data,
          }),
        );
        data.append("_method", "PUT");
      } catch (e) {
        this.$toast.error(this.$t("shop.error_saving_content"));
        this.loading = false;
        return;
      }

      this.$api
        .post("/v1/testQr/update", data, {
          headers: {
            "Content-Type": "application/from-data",
          },
        })
        .then(({ data }) => {
          this.finish = final;
          if(final || !this.AutoSave)
             this.$toast.success(this.$t("shop.success_edit_store"));
          
          if (final) {
            // this.$router.push({ name: "qr.list" });
          } else if (!this.showGatewayPopup && this.e6 === 2 && !this.AutoSave) {
            this.e6 = 3;
          }
        })
        .catch(({ response }) => {
          this.$toast.error(
            response?.data?.message || this.$t("shop.error_saving_content"),
          );
        })
        .finally(() => {
          this.loading = false;
          this.isAutoSaving = false;
        });
    },
    async updateShopSettings() {
      this.loading = true;
      if (this.$refs.qrShop) {
        await this.$refs.qrShop
          .setCartSetting()
          .then((data) => this.e6++)
          .finally(() => {
            this.setShopNotice();
            setTimeout(() => {
              this.$router.replace({ name: "qr.list" });
            }, 500);
            this.loading = false;
          });
      } else {
        this.loading = false;
      }
    },
    async setShopNotice() {
      if (this.$refs.qrShop) {
        await this.$refs.qrShop.setShopNotice();
      }
    },
    fixData(input) {
      if (!input.banner) {
        input.banner = {
          gallery: null,
        };
      }
      if (!input.pdf) input.pdf = null;
      if (!input.blog) input.blog = null;
      if (!input.service) input.service = null;
      if (!input.consultation || input.consultation.length == 0)
        input.consultation = {
          title: "فرم درخواست",
          description: "",
          sectionColor: { backGround: "", text: "" },
          conform: false,
        };

      if (!input.gallery) {
        input.gallery = [{ name: this.$t("shop.photo_gallery"), images: [] }];
      } else if (typeof input.gallery === "string") {
        try {
          input.gallery = JSON.parse(input.gallery);
        } catch (e) {}
      }
      if (!input.video_gallery) input.video_gallery = null;
      if (!input.service) {
        input.service = [
          {
            title: this.$t("shop.post_1"),
            content: "",
            gallery: [{ name: "", images: [] }],
            color: null,
            icon: null,
          },
        ];
      }
      if (!input.blog) {
        input.blog = [
          {
            title: this.$t("shop.post_1"),
            content: "",
            gallery: [{ name: "", images: [] }],
            color: null,
            icon: null,
          },
        ];
      }
      if (!input.shopLoginConfig) {
        input.shopLoginConfig = {
          shopLogo: [
            {
              value: "logo",
              name: this.$t("shop.logo"),
              logo: "",
            },
            {
              value: "background",
              name: this.$t("shop.background_image"),
              background: "",
            },
          ],
          configs: {
            subtitle: "",
          },
        };
      }

      return input;
    },
  },
};
</script>

<style scoped>
[dir="rtl"] .contentinfo,
[dir="rtl"] .rowinfo {
  text-align: right;
}
[dir="ltr"] .contentinfo,
[dir="ltr"] .rowinfo {
  text-align: left;
}

.sticky-preview {
  position: -webkit-sticky;
  position: sticky;
  top: 0px !important;
  align-self: flex-start;
  height: max-content;
  z-index: 10;
}
</style>
